import { axios } from '@utils';
import VerifyAccount from '@components/onboarding/verify-account';
import VerificationMethods from '@components/onboarding/verification-methods';

export default {
  components: {
    VerificationMethods,
    VerifyAccount,
  },
  data() {
    return {
      verifyMethod: undefined,
      codeEntered: undefined,
      codeVerified: false,
      errorMessages: '',
    };
  },
  methods: {
    async sendCode(
      userEmail,
      facilityPhoneNumber,
      facilityEmail,
      retry = false,
    ) {
      await axios.put(`/${retry ? 'request_new_verification_code' : 'send_code'}.json`, {
        email: userEmail?.toLowerCase(),
        facility_phone_number: facilityPhoneNumber,
        facility_email: facilityEmail?.toLowerCase(),
        method: this.verifyMethod,
      })
        .then((response) => {
          this.errorMessages = '';
          if (!response.data.success) {
            this.errorMessages = response.data.message;
          }
        });
    },
    async verifyAccount(userEmail) {
      await axios.put('/verify_user.json', { email: userEmail?.toLowerCase(), verification_code: this.codeEntered })
        .then((response) => {
          if (response.data.success && response.status === 200) {
            this.codeVerified = true;
          } else if (response.data.message.length > 0) {
            this.codeEntered = undefined;
            this.codeVerified = false;
            this.errorMessages = response.data.message;
          }
        });
    },
  },
};
